import React from "react";
var __jsx = React.createElement;
import stl from "./RemoveFiltersNote.module.css";
import useHelpers from "@hooks/useHelpers";
import { useTranslation } from "@i18n";
var RemoveFiltersNote = function RemoveFiltersNote() {
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement("div", {
    id: "filter-remove-note",
    className: stl.noteContainer
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, t("try_adjusting_filters", {
    ns: "web_search"
  })), " ", /*#__PURE__*/React.createElement("span", null, t("find_matching_search_results", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("button", {
    id: "filter-remove-note-reset-btn",
    onClick: function onClick() {
      navigateTo("/filters");
    }
  }, t("reset_filters", {
    ns: "web_search"
  })));
};
export default RemoveFiltersNote;